// Cosmetic skin-tone label for the model's 1–6 tone index.
//
// The analysis returns the index on the Fitzpatrick scale, but that scale is a
// dermatological classification; Kivo is a cosmetic, non-medical service, so
// users only ever see a plain colour description used to match products and
// shades. Mirrored in the mobile app (skin_tone.dart) — keep the two in sync.

const SKIN_TONE_LABELS = ['Very light', 'Light', 'Light-medium', 'Medium', 'Tan', 'Deep'] as const;

/** "Medium" for 4; an em dash when the index is missing or out of range. */
export function skinToneLabel(index: number | null | undefined): string {
  if (typeof index !== 'number' || !Number.isInteger(index) || index < 1 || index > SKIN_TONE_LABELS.length) {
    return '—';
  }
  return SKIN_TONE_LABELS[index - 1];
}
